import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, admin = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading)
    return <div className="pt-40 pb-40 text-center text-zinc-400 text-sm" data-testid="auth-loading">Loading…</div>;

  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/403" replace />;

  return children;
};
